import React from "react";
import PayrollRomms from "../../payroll/PayrollRomms";

interface OtherIncomeRommsProps {
  onBack: () => void;
}

export default function OtherIncomeRomms({ onBack }: OtherIncomeRommsProps) {
  return <PayrollRomms onBack={onBack} onComplete={() => {}} workspace="Other Income" />;
}


